import { IDataAttributeMap, IFalconTheme } from '@se-admin/falcon';
import { IAffiliateDetails } from '../../common/contexts/ApplicationContext';
import { ISale } from '../../common/types/apiSchema';

export enum SaleCardVariant {
  normal = 'normal',
  small = 'small',
}

export interface ISaleCardProps {
  dataAttributes?: IDataAttributeMap;
  sale: ISale;
  userId?: string;
  affiliateDetails?: IAffiliateDetails;
  favouriteSales?: string[];
  isMobile?: boolean;
  baseUrl?: string;
  className?: string;
  /** Variant */
  variant?: SaleCardVariant;
  trackingPosition?: number;
  onSizeChange?: () => void;
  showTooltip?: boolean;
  theme?: IFalconTheme;
  trackPositionOnClick?: boolean;
}
